import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import "./select.scss";

function Select(props) {
  const { options, value, placeholder, onChange, id, label, layoutStyle, labelColSize, inputColSize, validationMsg, required, name } = props;

  const renderOptions = (options) => {
    return options.map((option) => {
      if (option.options) {
        // This is an option group
        return (
          <optgroup key={option.label} label={option.label}>
            {renderOptions(option.options)}
          </optgroup>
        );
      } else {
        // This is a single option
        return (
          <option key={option.label} disabled={option.disabled} value={option.value}>
            {option.label}
          </option>
        );
      }
    });
  };

  const renderSelect = () => (
    <Form.Select id={id} value={value} onChange={onChange} name={name} aria-label="Select">
      <option>{placeholder}</option>
      {renderOptions(options)}
    </Form.Select>
  );

  const renderLayout = () => {
    switch (layoutStyle) {
    case "horizontal":
      return (
        <Row>
          <Col md={labelColSize || 5}>
            <Form.Label htmlFor={id}>
              {label} {required && <span className="text-danger">*</span>}
            </Form.Label>
          </Col>
          <Col md={inputColSize || 7}>
            {renderSelect()}
            {validationMsg && <div className="text-danger validation-msg">{validationMsg}</div>}
          </Col>
        </Row>
      );
    case "vertical":
    default:
      return (
        <div>
          <Form.Label htmlFor={id}>
            {label} {required && <span className="text-danger">*</span>}
          </Form.Label>
          {renderSelect()}
          {validationMsg && <div className="text-danger validation-msg">{validationMsg}</div>}
        </div>
      );
    }
  };

  return renderLayout();
}

export default Select;